import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router';
import { createQuiz, clearCreatedQuiz } from '../../../../data/quiz/actions';
import { createCalendar, clearCreatedCalendar } from '../../../../data/calendar/actions';
import TemplateChoice from './components/templateChoice/TemplateChoice';
import NameChoice from './components/nameChoice/NameChoice';
import { getLangIdByName } from '../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly handleToggleTemplateWizard?: *, readonly history?: {push: *}}>}
 */
const TemplateWizzard = React.memo(( { handleToggleTemplateWizard, history: { push } } ) => {

    const { localization: { content }, calendars: { createdCalendar }, quizzes: { createdQuiz } } = useSelector( state => state );
    const dispatch = new useDispatch();
    const [ step, setStep ] = useState( 1 );
    let display = false;

    const [ template, setTemplate ] = useState( {
        type: '',
        name: '',
        person_type_count: 2,
        lang: 1,
    } );
    const QUIZ = 'quiz';
    const CALENDAR = 'calendar';
    const PERSON = 'person';
    const ACADEMY = 'academy';

    const nextStep = () => {
        let theStep = step;
        setStep( ++theStep );
    };

    const makeTemplateChoice = type => () => {
        setTemplate(
            {
                ...template,
                type
            }
        );
        nextStep();
    };

    const changeTemplateName = e => {
        setTemplate( { ...template, name: e.target.value } );
    };

    const changePersonTypesCount = e => {

        setTemplate( {
            ...template,
            person_type_count: Number.parseInt( e.target.value ) || 0
        } );
    };

    const changeTemplateLanguage = ( langName ) => {
        setTemplate( { ...template, lang: getLangIdByName( langName ) } );
    };

    const createTemplate = () => {
        const { name, lang, type, person_type_count } = template;

        switch ( type ) {
            case QUIZ:
                return dispatch( createQuiz( { name, lang, quiz_type: 'quiz' } ) );
            case PERSON:
                return dispatch( createQuiz( { name, lang, quiz_type: 'person', person_type_count } ) );
            case ACADEMY:
                return dispatch( createQuiz( { name, lang, quiz_type: 'academy', person_type_count } ) );
            case CALENDAR:
                return dispatch( createCalendar( name, lang ) );
            default:
                return `${ content.dashboard.no_such_template }`;
        }
    };

    useEffect( () => {

        if ( createdCalendar ) {
            dispatch( clearCreatedCalendar() );
        } else if ( createdQuiz ) {
            dispatch( clearCreatedQuiz() );
        }

    }, [ createdCalendar, createdQuiz ] );

    useEffect( () => {
        const { type } = template;

        if ( createdCalendar ) {
            push( '/calendar/' + createdCalendar + '/editor/' );
            handleToggleTemplateWizard();
        } else if ( createdQuiz ) {

            switch ( type ) {
                case QUIZ: {
                    push( '/quiz/' + createdQuiz + '/editor/' );
                    handleToggleTemplateWizard();
                    break;
                }
                case PERSON: {
                    push( '/person/' + createdQuiz + '/editor/' );
                    handleToggleTemplateWizard();
                    break;
                }
                case ACADEMY: {
                    push( '/academy/' + createdQuiz + '/editor/' );
                    handleToggleTemplateWizard();
                    break;
                }

                default: {
                    push( '/quiz/' + createdQuiz + '/editor/' );
                    handleToggleTemplateWizard();
                }
            }
        }
    }, [ createdCalendar, createdQuiz ] );


    return (
        <Fragment>
            { step === 1 &&
            <TemplateChoice
                content={ content }
                handleToggleTemplateWizard={ handleToggleTemplateWizard }
                handleTemplateChoice={ makeTemplateChoice }
            /> }
            { step === 2 &&
            <NameChoice
                content={ content }
                handleToggleTemplateWizard={ handleToggleTemplateWizard }
                handleTemplateNameChange={ changeTemplateName }
                handlePersonTypesCountChange={ changePersonTypesCount }
                handleTemplateLanguageChange={ changeTemplateLanguage }
                handleTemplateCreation={ createTemplate }
                template={ template }
                display={ display }
            />
            }
        </Fragment>
    );
});

export default withRouter( TemplateWizzard );